import { api, formatParams, config } from "@/utils/axios";

// 获取二维码
export function renderLogin(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/dingtalk/render?url=${params.url}`,
    })
  );
}

// 登录
export function login(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/login/in`,
    })
  );
}

// 新增用户
export function insertUser(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/user/saveUser`,
    })
  );
}

// 修改用户信息
export function update(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/user/update/${params.id}`,
    })
  );
}

// 删除用户
export function userDelete(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/user/del/${params.id}`,
    })
  );
}

// 用户列表
export function userList(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/user/getUser`,
    })
  );
}

// 根据id查询用户详情
export function userDetail(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/user/find/${params.id}`,
    })
  );
}

// 查询当前用户详情
export function getUserDetails(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/user/findUser`,
    })
  );
}

// 用户角色分配
export function allot(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/user/saveUserAndRole?userId=${params.userId}`,
    })
  );
}

// 用户修改密码
export function updatePassWord(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/user/updatePassWord/${params.id}`,
    })
  );
}

// 获取日志
export function getLogInfo(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/user/getLogInfo`,
    })
  );
}

// 获取所有用户（不带部门角色）
export function getUserAll(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/user/getUserAll`,
    })
  );
}

// 授权码登录
export function codeLogin(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/login/codeLogin?code=${params}`,
    })
  );
}

// 获取用户的基础信息全部的（用户）
export function getUserAllBaseInfo(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/user/allUserBaseInfo`,
    })
  );
}

// 获取用户所属部门
export function getDeptByUserId(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/sysSection/findRoleByUserId`,
      params,
    })
  );
}
